@if(service.viewDroplistItems.length){
<div class='experience-engagements-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.ContactReqs) {
	<experience-contact-request-view-part></experience-contact-request-view-part>
	}
	@case (service.viewId.OpenEngagements) {
	<experience-open-engagements-view-part></experience-open-engagements-view-part>
	}
	@case (service.viewId.CompletedEngagements) {
	<experience-completed-engagements-view-part></experience-completed-engagements-view-part>
	}
	@case (service.viewId.FollowUps) {
	<experience-follow-ups-view-part></experience-follow-ups-view-part>
	}
	}
	}

</div>
}